export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return (ua.includes('safari') && !ua.includes('chrome')) || isIOS();
};

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const getSpeechRecognition = () => {
  if (typeof window === 'undefined') return null;
  
  // Try to get the SpeechRecognition object for the current browser
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  
  if (!SpeechRecognition) {
    console.warn('Speech recognition is not supported in this browser');
    return null;
  }

  return SpeechRecognition;
};